import { render, staticRenderFns } from "./bloodGlucose.vue?vue&type=template&id=4dbc4970&scoped=true"
import script from "./bloodGlucose.vue?vue&type=script&lang=js"
export * from "./bloodGlucose.vue?vue&type=script&lang=js"
import style0 from "./bloodGlucose.vue?vue&type=style&index=0&id=4dbc4970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc4970",
  null
  
)

export default component.exports